import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {

  canActivate(): boolean {

    // @todo check jwt
    return true;
  }
}
